import {PlayersStatisticsSubjectsApiModel} from "./players-statistics.subjects.api-model";
import {BaseDomainModel} from "../../../../../infrastructure/models/base-domain-model";

export class PlayersStatisticsSubjectsDomainModel extends BaseDomainModel {
  apiModel: PlayersStatisticsSubjectsApiModel;

  get id(): Number {
    return this.apiModel.id;
  }

  get name(): String {
    return this.apiModel.name;
  }
}